<template>
  <section class="admin">
    <b-container>
      <b-row>
        <b-col cols="12" md="6" lg="3">
          <div class="logo">Админ-панель</div>
        </b-col>
        <b-col cols="12" md="6" lg="3">
          <nav class="nav">
            <router-link to="/">На главную</router-link>
          </nav>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="8">
          <div class="box">
            <b-container>
              <b-row>
                <b-col cols="12">
                  <h3>Редактор контента (Info/About/Change/AML)</h3>
                </b-col>
                <b-col cols="12" md="3">
                  <label class="editor-label" for="editor-locale">Язык</label>
                  <select
                    id="editor-locale"
                    class="editor-control"
                    v-model="textEditor.locale"
                    @change="onEditorLocaleChange"
                  >
                    <option value="uk">uk</option>
                    <option value="en">en</option>
                    <option value="ru">ru</option>
                  </select>
                </b-col>
                <b-col cols="12" md="3">
                  <label class="editor-label" for="editor-scope">Раздел</label>
                  <select
                    id="editor-scope"
                    class="editor-control"
                    v-model="textEditor.scope"
                    @change="onEditorScopeChange"
                  >
                    <option v-for="scope in editorScopes" :key="scope.value" :value="scope.value">
                      {{ scope.label }}
                    </option>
                  </select>
                </b-col>
                <b-col cols="12" md="6">
                  <label class="editor-label" for="editor-key">Поле</label>
                  <select
                    id="editor-key"
                    class="editor-control"
                    v-model="textEditor.key"
                    @change="onEditorKeyChange"
                  >
                    <option disabled value="">Выберите поле</option>
                    <option v-for="option in contentFieldOptions" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </b-col>
                <b-col cols="12">
                  <label class="editor-label" for="editor-text">
                    {{ isListField ? 'Список' : 'Текст' }}
                  </label>
                  <div v-if="isListField" class="editor-list">
                    <div class="editor-list_row" v-for="(item, index) in textEditor.listValue" :key="`editor-item-${index}`">
                      <span class="editor-list_index">{{ index + 1 }}.</span>
                      <input class="editor-list_input" type="text" v-model="textEditor.listValue[index]" />
                      <button class="btn editor-list_btn" @click="moveListItem(index, -1)" :disabled="index === 0">up</button>
                      <button
                        class="btn editor-list_btn"
                        @click="moveListItem(index, 1)"
                        :disabled="index === textEditor.listValue.length - 1"
                      >
                        down
                      </button>
                      <button class="btn editor-list_btn" @click="removeListItem(index)">x</button>
                    </div>
                    <button class="btn editor-list_add" @click="addListItem">+ Добавить строку</button>
                  </div>
                  <textarea v-else id="editor-text" v-model="textEditor.value"></textarea>
                </b-col>
                <b-col cols="12">
                  <button class="btn btn__succes" @click="saveAmlText" :disabled="!textEditor.key || textEditor.saving">
                    {{ textEditor.saving ? 'Сохранение...' : 'Сохранить текст' }}
                  </button>
                  <p v-if="textEditor.status" class="editor-status">{{ textEditor.status }}</p>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="8" v-if="commissionRates.BTC">
          <div class="box">
            <b-container>
              <b-row>
                <b-col cols="12">
                  <h3>Настройка комиссий</h3>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="wrap">
                    <h3>BTC</h3>
                    <button class="btn btn__icon" @click="edit.BTC = !edit.BTC">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.BTC.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.BTC"
                      v-model.number="changedCommissionRates.BTC.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.BTC.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.BTC"
                      v-model.number="changedCommissionRates.BTC.sell"
                    />
                  </transition>
                  <div class="wrap">
                    <h3>ETH</h3>
                    <button class="btn btn__icon" @click="edit.ETH = !edit.ETH">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.ETH.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.ETH"
                      v-model.number="changedCommissionRates.ETH.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.ETH.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.ETH"
                      v-model.number="changedCommissionRates.ETH.sell"
                    />
                  </transition>
                  <div class="wrap">
                    <h3>USDT</h3>
                    <button class="btn btn__icon" @click="edit.USDT = !edit.USDT">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.USDT.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.USDT"
                      v-model.number="changedCommissionRates.USDT.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.USDT.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.USDT"
                      v-model.number="changedCommissionRates.USDT.sell"
                    />
                  </transition>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="wrap">
                    <h3>USD</h3>
                    <button class="btn btn__icon" @click="edit.USD = !edit.USD">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.USD.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.USD"
                      v-model.number="changedCommissionRates.USD.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.USD.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.USD"
                      v-model.number="changedCommissionRates.USD.sell"
                    />
                  </transition>
                  <div class="wrap">
                    <h3>EUR</h3>
                    <button class="btn btn__icon" @click="edit.EUR = !edit.EUR">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.EUR.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.EUR"
                      v-model.number="changedCommissionRates.EUR.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.EUR.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.EUR"
                      v-model.number="changedCommissionRates.EUR.sell"
                    />
                  </transition>
                  <div class="wrap">
                    <h3>UAH</h3>
                    <button class="btn btn__icon" @click="edit.UAH = !edit.UAH">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Отдаете (покупка)</p>
                    <p class="settings-label_number">{{commissionRates.UAH.buy}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.UAH"
                      v-model.number="changedCommissionRates.UAH.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Получаете (продажа)</p>
                    <p class="settings-label_number">{{commissionRates.UAH.sell}}%</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="edit.UAH"
                      v-model.number="changedCommissionRates.UAH.sell"
                    />
                  </transition>
                </b-col>
                <b-col cols="12" md="6" offset-md="3">
                  <button class="btn btn__succes" @click="changeCommissionRates">Сохранить</button>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-col>
        <b-col cols="12" lg="8" v-if="fiatRates.USD">
          <div class="box">
            <b-container>
              <b-row>
                <b-col cols="12">
                  <h3>Настройки курсов</h3>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="6">
                  <div class="wrap">
                    <h3>USD</h3>
                    <button class="btn btn__icon" @click="fiatEdit.USD = !fiatEdit.USD">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 477.873 477.873"
                        style="enable-background:new 0 0 477.873 477.873;"
                        xml:space="preserve"
                        width="512px"
                        height="512px"
                        class
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                d="M392.533,238.937c-9.426,0-17.067,7.641-17.067,17.067V426.67c0,9.426-7.641,17.067-17.067,17.067H51.2    c-9.426,0-17.067-7.641-17.067-17.067V85.337c0-9.426,7.641-17.067,17.067-17.067H256c9.426,0,17.067-7.641,17.067-17.067    S265.426,34.137,256,34.137H51.2C22.923,34.137,0,57.06,0,85.337V426.67c0,28.277,22.923,51.2,51.2,51.2h307.2    c28.277,0,51.2-22.923,51.2-51.2V256.003C409.6,246.578,401.959,238.937,392.533,238.937z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M458.742,19.142c-12.254-12.256-28.875-19.14-46.206-19.138c-17.341-0.05-33.979,6.846-46.199,19.149L141.534,243.937    c-1.865,1.879-3.272,4.163-4.113,6.673l-34.133,102.4c-2.979,8.943,1.856,18.607,10.799,21.585    c1.735,0.578,3.552,0.873,5.38,0.875c1.832-0.003,3.653-0.297,5.393-0.87l102.4-34.133c2.515-0.84,4.8-2.254,6.673-4.13    l224.802-224.802C484.25,86.023,484.253,44.657,458.742,19.142z M434.603,87.419L212.736,309.286l-66.287,22.135l22.067-66.202    L390.468,43.353c12.202-12.178,31.967-12.158,44.145,0.044c5.817,5.829,9.095,13.72,9.12,21.955    C443.754,73.631,440.467,81.575,434.603,87.419z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#94A1B2"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Покупка</p>
                    <p
                      class="settings-label_number"
                    >EUR {{fiatRates.USD.EUR.buy}} UAH {{fiatRates.USD.UAH.buy}}</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="fiatEdit.USD"
                      v-model.number="changedFiatRates.USD.EUR.buy"
                    />
                  </transition>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="fiatEdit.USD"
                      v-model.number="changedFiatRates.USD.UAH.buy"
                    />
                  </transition>
                  <div class="settings-label">
                    <p class="settings-label_name">Продажа</p>
                    <p
                      class="settings-label_number"
                    >EUR {{fiatRates.USD.EUR.sell}} UAH {{fiatRates.USD.UAH.sell}}</p>
                  </div>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="fiatEdit.USD"
                      v-model.number="changedFiatRates.USD.EUR.sell"
                    />
                  </transition>
                  <transition name="fade-slideUp">
                    <input
                      type="number"
                      step="any"
                      v-if="fiatEdit.USD"
                      v-model.number="changedFiatRates.USD.UAH.sell"
                    />
                  </transition>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="wrap">
                    <h3>EUR</h3>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Покупка</p>
                    <p
                      class="settings-label_number"
                    >USD {{fiatRates.EUR.USD.buy}} UAH {{fiatRates.EUR.UAH.buy}}</p>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Продажа</p>
                    <p
                      class="settings-label_number"
                    >USD {{fiatRates.EUR.USD.sell}} UAH {{fiatRates.EUR.UAH.sell}}</p>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="wrap">
                    <h3>UAH</h3>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Покупка</p>
                    <p
                      class="settings-label_number"
                    >USD {{fiatRates.UAH.USD.buy}} EUR {{fiatRates.UAH.EUR.buy}}</p>
                  </div>
                  <div class="settings-label">
                    <p class="settings-label_name">Продажа</p>
                    <p
                      class="settings-label_number"
                    >USD {{fiatRates.UAH.USD.sell}} EUR {{fiatRates.UAH.EUR.sell}}</p>
                  </div>
                </b-col>
                <b-col cols="12" md="6" offset-md="3">
                  <button class="btn btn__succes" @click="changeFiatRates">Сохранить</button>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
'use strict';
export default {
  data: () => ({
    changeSuccess: false,
    changeFail: false,
    textEditor: {
      locale: "uk",
      scope: "amlKyc",
      key: "",
      value: "",
      listValue: [],
      status: "",
      saving: false
    },
    edit: {
      BTC: false,
      ETH: false,
      USDT: false,
      USD: false,
      EUR: false,
      UAH: false
    },
    fiatEdit: {
      USD: false
    }
  }),
  computed: {
    commissionRates() {
      let rates = this.$store.getters.commissionRates;

      for (let rate in rates) {
        rates[rate].buy = parseFloat((rates[rate].buy * 100).toFixed(3));
        rates[rate].sell = parseFloat((rates[rate].sell * 100).toFixed(3));
      }

      return rates;
    },
    fiatRates() {
      return this.$store.getters.fiatRates;
    },
    changedCommissionRates() {
      return JSON.parse(JSON.stringify(this.commissionRates));
    },
    changedFiatRates() {
      return JSON.parse(JSON.stringify(this.fiatRates));
    },
    editorScopes() {
      return [
        { value: "info", label: "Info" },
        { value: "about", label: "About" },
        { value: "change", label: "Change" },
        { value: "amlKyc", label: "AML/KYC" }
      ];
    },
    contentFieldOptions() {
      const localeMessages = this.$i18n.getLocaleMessage(this.textEditor.locale) || {};
      const scopeMessages = localeMessages[this.textEditor.scope] || {};

      return this.collectEditableFields(scopeMessages);
    },
    selectedFieldOption() {
      return this.contentFieldOptions.find((option) => option.value === this.textEditor.key) || null;
    },
    isListField() {
      return this.selectedFieldOption && this.selectedFieldOption.type === "list";
    }
  },
  created: async function() {
    await this.$store.dispatch("getСommissionRates");
    await this.$store.dispatch("getFiatRates");
    await this.$store.dispatch("getTextOverrides");
    this.initializeTextEditor();
  },
  methods: {
    clg() {
      console.log(this.fiatRates);
    },
    async changeCommissionRates() {
      let changedCommissionRates = this.changedCommissionRates;

      for (let rate in changedCommissionRates) {
        changedCommissionRates[rate].buy = parseFloat(
          changedCommissionRates[rate].buy / 100
        );
        changedCommissionRates[rate].sell = parseFloat(
          changedCommissionRates[rate].sell / 100
        );
      }

      try {
        this.$store.dispatch("changeСommissionRates", changedCommissionRates);
        this.$store.dispatch("getСommissionRates");
        this.changeSuccess = true;
      } catch (error) {
        this.changeFail = true;
        console.log(error);
      }
    },
    async changeFiatRates() {
      let changedFiatRates = this.changedFiatRates;

      try {
        this.$store.dispatch("changeFiatRates", changedFiatRates);
        this.$store.dispatch("getFiatRates");
        this.changeSuccess = true;
      } catch (error) {
        this.changeFail = true;
        console.log(error);
      }
    },
    initializeTextEditor() {
      if (!this.contentFieldOptions.length) {
        return;
      }

      if (!this.textEditor.key) {
        this.textEditor.key = this.contentFieldOptions[0].value;
      }

      this.syncEditorValue();
    },
    onEditorLocaleChange() {
      this.textEditor.key = "";
      this.initializeTextEditor();
    },
    onEditorScopeChange() {
      this.textEditor.key = "";
      this.initializeTextEditor();
    },
    onEditorKeyChange() {
      this.syncEditorValue();
    },
    getEditorPath() {
      if (!this.textEditor.scope || !this.textEditor.key) {
        return "";
      }

      return `${this.textEditor.scope}.${this.textEditor.key}`;
    },
    collectEditableFields(source, prefix = "") {
      if (!source || typeof source !== "object") {
        return [];
      }

      let fields = [];

      Object.keys(source).forEach((key) => {
        const value = source[key];
        const path = prefix ? `${prefix}.${key}` : key;

        if (typeof value === "string") {
          fields.push({ value: path, label: path, type: "text" });
          return;
        }

        if (Array.isArray(value) && value.every((item) => typeof item === "string")) {
          fields.push({ value: path, label: `${path} [list]`, type: "list" });
          return;
        }

        if (value && typeof value === "object" && !Array.isArray(value)) {
          fields = fields.concat(this.collectEditableFields(value, path));
        }
      });

      return fields;
    },
    getValueByPath(source, path) {
      return path.split(".").reduce((value, part) => {
        if (value && typeof value === "object") {
          return value[part];
        }

        return undefined;
      }, source);
    },
    buildNestedValue(path, value) {
      return path
        .split(".")
        .slice()
        .reverse()
        .reduce((accumulator, part) => ({ [part]: accumulator }), value);
    },
    setValueByPath(target, path, value) {
      const parts = path.split(".");
      const lastKey = parts.pop();
      let cursor = target;

      parts.forEach((part) => {
        if (!cursor[part] || typeof cursor[part] !== "object") {
          cursor[part] = {};
        }

        cursor = cursor[part];
      });

      cursor[lastKey] = value;
    },
    syncEditorValue() {
      const editorPath = this.getEditorPath();

      if (!editorPath) {
        this.textEditor.value = "";
        this.textEditor.listValue = [];
        return;
      }

      const localeMessages = this.$i18n.getLocaleMessage(this.textEditor.locale) || {};
      const currentValue = this.getValueByPath(localeMessages, editorPath);

      if (this.isListField) {
        this.textEditor.listValue = Array.isArray(currentValue)
          ? currentValue.map((item) => `${item}`)
          : [];
        this.textEditor.value = "";
      } else {
        this.textEditor.value = typeof currentValue === "string" ? currentValue : "";
        this.textEditor.listValue = [];
      }

      this.textEditor.status = "";
    },
    getEditorPayload() {
      if (this.isListField) {
        return this.textEditor.listValue
          .map((item) => `${item}`.trim())
          .filter((item) => item.length > 0);
      }

      return this.textEditor.value;
    },
    addListItem() {
      this.textEditor.listValue.push("");
    },
    removeListItem(index) {
      this.textEditor.listValue.splice(index, 1);
    },
    moveListItem(index, direction) {
      const nextIndex = index + direction;

      if (nextIndex < 0 || nextIndex >= this.textEditor.listValue.length) {
        return;
      }

      const listCopy = this.textEditor.listValue.slice();
      const temp = listCopy[index];
      listCopy[index] = listCopy[nextIndex];
      listCopy[nextIndex] = temp;
      this.textEditor.listValue = listCopy;
    },
    async saveAmlText() {
      const editorPath = this.getEditorPath();

      if (!editorPath) {
        return;
      }

      this.textEditor.saving = true;
      this.textEditor.status = "";
      const payload = this.getEditorPayload();

      try {
        await this.$store.dispatch("saveTextOverride", {
          locale: this.textEditor.locale,
          key: editorPath,
          value: payload
        });

        const localeMessages = JSON.parse(
          JSON.stringify(this.$i18n.getLocaleMessage(this.textEditor.locale) || {})
        );
        this.setValueByPath(localeMessages, editorPath, payload);
        this.$i18n.setLocaleMessage(this.textEditor.locale, localeMessages);

        this.textEditor.status = "Сохранено";
      } catch (error) {
        this.textEditor.status = "Ошибка сохранения";
      } finally {
        this.textEditor.saving = false;
      }
    }
  }
};
</script>

<style lang='sass'>
.admin
  input
    width: 100%
  textarea
    width: 100%
    min-height: 220px
    resize: vertical
  .editor-list
    width: 100%
    &_row
      display: flex
      align-items: center
      margin-bottom: 0.5rem
    &_index
      width: 28px
      display: inline-block
    &_input
      margin-right: 0.5rem
      flex: 1
    &_btn
      margin-left: 0.25rem
      padding: 0.25rem 0.5rem
      min-width: 48px
      background-color: #3a3f45
      color: #fff
    &_add
      margin-top: 0.5rem
      background-color: #3a3f45
      color: #fff
  .editor-label
    display: block
    margin-bottom: 0.35rem
  .editor-control
    width: 100%
    min-height: 40px
  .editor-status
    margin-top: 0.75rem
    margin-bottom: 0
  .btn__succes
    margin-top: 1rem
  .wrap
    display: flex
    justify-content: flex-start
    align-items: center
    h3
      margin: 0 10px .5rem 0
    .btn
      margin: 0 0 .5rem 0

.settings-label
  width: 100%
  margin-bottom: 1rem
  padding: 0.75rem
  display: flex
  align-items: center
  background-color: #242629
  border-radius: 5px
  p
    margin-bottom: 0
    padding: 0 5px
  &_name
    margin-right: auto
</style>